import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=633d9878&scoped=true&"
import script from "./Grades.vue?vue&type=script&lang=js&"
export * from "./Grades.vue?vue&type=script&lang=js&"
import style0 from "./Grades.vue?vue&type=style&index=0&id=633d9878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d9878",
  null
  
)

export default component.exports